


// import { useState } from "react";
// import axiosInstance from "../api/axiosInstance";
// import { validateLeadForm } from "../Validations/leadSchema";

// const initialForm = {
//   validationType: "Electricity Only",

//   // ================= GENERAL =================
//   businessName:    "",
//   businessPhone:   "",
//   businessAddress: "",
//   postalCode:      "",
//   contactName:     "",
//   billingName:     "",
//   mpan:            "",  // = mpan_core = leads.mpan = electricity_details.mpan_core

//   // ================= ELECTRICITY =================
//   elecSupplier:      "",
//   elecAccount:       "",
//   elecMonthYear:     "",
//   elecContractEnd:   "",
//   elecPayment:       "",
//   elecMeterType:     "",
//   elecDayRate:       "",
//   elecNightRate:     "",
//   elecEveRate:       "",
//   elecStandingCharge:"",
//    elecEseRate:      "",
//   elecSupplyNumber:  "",  // = mpan_top_line  e.g. S 03 0393 H08
//   elecAvgBill:       "",
//   elecBillType:      "MONTHLY",
//   elecBillRange:     "",
//   elecMSN:           "",

//   // ================= GAS =================
//   gasSupplier:          "",
//   gasAccount:           "",
//   gasMonthYear:         "",
//   gasContractEnd:       "",
//   gasPayment:           "",
//   gasAnnualConsumption: "",
//   gasDayRate:           "",
//   gasStandingCharge:    "",
//   gasMprnNumber:        "",
//   gasAvgBill:           "",
//   gasBillingFreq:       "MONTHLY",
//   gasBillRange:         "",
//   gasMSN:               "",

//   // ================= QUALITY =================
//   email:           "",
//   callbackDate:    "",
//   agentFeedback:   "",
//   qualityFeedback: "",
//   leadDisposition: "",
//   voxFile:         null,
// };

// export function useLeadForm() {
//   const [form,        setForm]        = useState(initialForm);
//   const [errors,      setErrors]      = useState({});
//   const [isSaving,    setIsSaving]    = useState(false);
//   const [serverError, setServerError] = useState("");

//   // ================= HELPERS =================
//   const toDateOrNull   = (v) => v && v.trim() !== "" ? v         : null;
//   const toNumberOrNull = (v) => v !== "" && v != null ? Number(v): null;
//   const toMonthOrNull  = (v) => v && v.trim() !== "" ? `${v}-01` : null;

//   // ================= FIELD SETTER =================
//   const setField = (field) => (e) => {
//     const value =
//       e?.target?.type === "file"
//         ? e.target.files[0]
//         : e?.target?.value ?? e;

//     setForm((prev) => ({ ...prev, [field]: value }));

//     if (errors[field]) {
//       setErrors((prev) => ({ ...prev, [field]: undefined }));
//     }
//   };

//   // ================= RESET =================
//   const reset = () => {
//     setForm(initialForm);
//     setErrors({});
//     setServerError("");
//   };

//   // ================= SAVE LEAD =================
//   const saveLead = async () => {

//     // ── Validate ──────────────────────────────────────────
//     const { isValid, errors: validationErrors } = validateLeadForm(form);

//     if (!isValid) {
//       setErrors(validationErrors);
//       const firstErrorKey = Object.keys(validationErrors)[0];
//       const el = document.querySelector(`[name="${firstErrorKey}"]`);
//       if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
//       return false;
//     }

//     try {
//       setIsSaving(true);
//       setServerError("");

//       const user = JSON.parse(localStorage.getItem("user"));

//       // ── Validation type mapping ───────────────────────────
//       const rawType = form.validationType?.trim();
//       let mappedValidationType = "elec";
//       if (rawType === "Electricity Only")       mappedValidationType = "elec";
//       else if (rawType === "Gas Only")          mappedValidationType = "gas";
//       else if (rawType === "Electricity + Gas") mappedValidationType = "both";

//       const showElec = mappedValidationType === "both" || mappedValidationType === "elec";
//       const showGas  = mappedValidationType === "both" || mappedValidationType === "gas";

//       // ── Build FormData ────────────────────────────────────
//       const formData = new FormData();

//       formData.append("lead_date",        new Date().toISOString());
//       formData.append("validation_type",  mappedValidationType);
//       formData.append("business_name",    form.businessName    || "");
//       formData.append("business_phone",   form.businessPhone   || "");
//       formData.append("contact_name",     form.contactName     || "");
//       formData.append("billing_name",     form.billingName     || "");
//       formData.append("business_address", form.businessAddress || "");
//       formData.append("postal_code",      form.postalCode      || "");
//       formData.append("created_by",       user?.id             || 1);
//       formData.append("mpan",             form.mpan            || "");  // → leads.mpan

//       // ── Electricity ───────────────────────────────────────
//       if (showElec) {
//         formData.append(
//           "electricity_details",
//           JSON.stringify({
//             current_supplier:    form.elecSupplier,
//             customer_account_no: form.elecAccount             || null,
//             month_and_year:      toMonthOrNull(form.elecMonthYear),  // → "2026-04-01"
//             contract_end_date:   toDateOrNull(form.elecContractEnd),
//             payment_method:      form.elecPayment,
//             meter_type:          form.elecMeterType,
//             day_rate:            toNumberOrNull(form.elecDayRate),
//             night_rate:          toNumberOrNull(form.elecNightRate),
//             eve_weekend_rate:    toNumberOrNull(form.elecEveRate),
//             eac_rate:            toNumberOrNull(form.elecEseRate),  
//             standing_charge:     toNumberOrNull(form.elecStandingCharge),
//             mpan_top_line:       form.elecSupplyNumber         || null,  // S 03 0393 H08
//             mpan_core:           form.mpan                     || null,  // 20 0000 2359 000
//             average_bill_amount: toNumberOrNull(form.elecAvgBill),
//             bill_type:           form.elecBillType             || "MONTHLY",
//             average_bill_range:  form.elecBillRange            || null,
//             msn_no:              form.elecMSN                  || null,
//           })
//         );
//       }

//       // ── Gas ───────────────────────────────────────────────
//       if (showGas) {
//         formData.append(
//           "gas_details",
//           JSON.stringify({
//             current_supplier:    form.gasSupplier,
//             customer_account_no: form.gasAccount              || null,
//             month_and_year:      toMonthOrNull(form.gasMonthYear),  // → "2026-04-01"
//             contract_end_date:   toDateOrNull(form.gasContractEnd),
//             payment_method:      form.gasPayment,
//             annual_consumption:  toNumberOrNull(form.gasAnnualConsumption),
//             day_rate:            toNumberOrNull(form.gasDayRate),
//             standing_charge:     toNumberOrNull(form.gasStandingCharge),
//             mprn_no:             form.gasMprnNumber            || null,
//             average_bill_amount: toNumberOrNull(form.gasAvgBill),
//             billing_frequency:   form.gasBillingFreq           || "MONTHLY",
//             average_bill_range:  form.gasBillRange             || null,
//             msn_no:              form.gasMSN                   || null,
//           })
//         );
//       }

//       // ── Quality Review ────────────────────────────────────
//       formData.append(
//         "quality_review",
//         JSON.stringify({
//           email:            form.email,
//           callback_date:    form.callbackDate    || null,
//           agent_feedback:   form.agentFeedback,
//           quality_feedback: form.qualityFeedback,
//           lead_disposition: form.leadDisposition,
//           reviewed_by:      null,
//         })
//       );

//       if (form.voxFile) {
//         formData.append("vox_file", form.voxFile);
//       }

//       const response = await axiosInstance.post(
//         "/leads/create",
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       console.log(response.data);
//       return true;

//     } catch (error) {
//       console.error(error);

//       const message = error?.response?.data?.message || "Something went wrong";
//       console.log("Error message:", message);

//       // ── Duplicate key handlers ────────────────────────────
//       if (message.includes("leads_mpan_key")) {
//         setErrors((prev) => ({
//           ...prev,
//           mpan: "This MPAN already exists",
//         }));

//       } else if (message.includes("electricity_details_mpan_core_unique")) {
//         setErrors((prev) => ({
//           ...prev,
//           mpan: "This MPAN Core already exists",
//         }));

//       } else if (message.includes("gas_details_mprn_no_key")) {
//         setErrors((prev) => ({
//           ...prev,
//           gasMprnNumber: "This MPRN already exists",
//         }));

//       } else {
//         setServerError(message);
//       }

//       return false;

//     } finally {
//       setIsSaving(false);
//     }
//   };

//   return {
//     form,
//     errors,
//     isSaving,
//     serverError,
//     setField,
//     reset,
//     saveLead,
//     setServerError,
//   };
// }


import { useState  } from "react";
import axiosInstance from "../api/axiosInstance";
import { validateLeadForm } from "../Validations/leadSchema";


const initialForm = {
  validationType: "Electricity Only",

  // ================= GENERAL =================
  businessName:    "",
  businessPhone:   "",
  businessAddress: "",
  postalCode:      "",
  contactName:     "",
  billingName:     "",
  mpan:            "",

  // ================= ELECTRICITY =================
  elecSupplier:      "",
  elecAccount:       "",
  elecMonthYear:     "",
  elecContractEnd:   "",
  elecPayment:       "",
  elecMeterType:     "",
  elecDayRate:       "",
  elecNightRate:     "",
  elecEveRate:       "",
  elecStandingCharge:"",
   elecEseRate:      "",
  elecSupplyNumber:  "",
  elecAvgBill:       "",
  elecBillType:      "MONTHLY",
  elecBillRange:     "",
  elecMSN:           "",

  // ================= GAS =================
  gasSupplier:          "",
  gasAccount:           "",
  gasMonthYear:         "",
  gasContractEnd:       "",
  gasPayment:           "",
  gasAnnualConsumption: "",
  gasDayRate:           "",
  gasStandingCharge:    "",
  gasMprnNumber:        "",
  gasAvgBill:           "",
  gasBillingFreq:       "MONTHLY",
  gasBillRange:         "",
  gasMSN:               "",

  // ================= QUALITY =================
  email:           "",
  callbackDate:    "",
  agentFeedback:   "",
  qualityFeedback: "",
  leadDisposition: "",
  voxFiles:        [], 
  attachments:     [],  // ← CHANGED: array instead of single voxFile
};

export function useLeadForm() {
  const [form,        setForm]        = useState(initialForm);
  const [errors,      setErrors]      = useState({});
  const [isSaving,    setIsSaving]    = useState(false);
  const [serverError, setServerError] = useState("");

  // ================= HELPERS =================
  const toDateOrNull   = (v) => v && v.trim() !== "" ? v         : null;
  const toNumberOrNull = (v) => v !== "" && v != null ? Number(v): null;
  const toMonthOrNull  = (v) => v && v.trim() !== "" ? `${v}-01` : null;

  // ================= FIELD SETTER =================
  const setField = (field) => (e) => {
    let value;

    if (e?.target?.type === "file") {
      value = e.target.multiple
        ? Array.from(e.target.files)   // ← multiple selection → array
        : e.target.files[0];
    } else {
      value = e?.target?.value ?? e;
    }

    setForm((prev) => ({ ...prev, [field]: value }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  // ================= REMOVE ONE VOX FILE ===============  ← NEW
  const removeVoxFile = (index) => {
    setForm((prev) => ({
      ...prev,
      voxFiles: prev.voxFiles.filter((_, i) => i !== index),
    }));
  };

  // ── REMOVE ONE ATTACHMENT ─────────────────────────  ← NEW
  const removeAttachment = (index) => {
    setForm((prev) => ({
      ...prev,
      attachments: prev.attachments.filter((_, i) => i !== index),
    }));
  };
  // ================= RESET =================
  const reset = () => {
    setForm(initialForm);
    setErrors({});
    setServerError("");
  };

  // ================= SAVE LEAD =================
  const saveLead = async () => {

    const { isValid, errors: validationErrors } = validateLeadForm(form);

    if (!isValid) {
      setErrors(validationErrors);
      const firstErrorKey = Object.keys(validationErrors)[0];
      const el = document.querySelector(`[name="${firstErrorKey}"]`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    try {
      setIsSaving(true);
      setServerError("");

      const user = JSON.parse(localStorage.getItem("user"));

      const rawType = form.validationType?.trim();
      let mappedValidationType = "elec";
      if (rawType === "Electricity Only")       mappedValidationType = "elec";
      else if (rawType === "Gas Only")          mappedValidationType = "gas";
      else if (rawType === "Electricity + Gas") mappedValidationType = "both";

      const showElec = mappedValidationType === "both" || mappedValidationType === "elec";
      const showGas  = mappedValidationType === "both" || mappedValidationType === "gas";

      const formData = new FormData();

      formData.append("lead_date",        new Date().toISOString());
      formData.append("validation_type",  mappedValidationType);
      formData.append("business_name",    form.businessName    || "");
      formData.append("business_phone",   form.businessPhone   || "");
      formData.append("contact_name",     form.contactName     || "");
      formData.append("billing_name",     form.billingName     || "");
      formData.append("business_address", form.businessAddress || "");
      formData.append("postal_code",      form.postalCode      || "");
      formData.append("created_by",       user?.id             || 1);
      formData.append("mpan",             form.mpan            || "");

      if (showElec) {
        formData.append(
          "electricity_details",
          JSON.stringify({
            current_supplier:    form.elecSupplier,
            customer_account_no: form.elecAccount             || null,
            month_and_year:      toMonthOrNull(form.elecMonthYear),
            contract_end_date:   toDateOrNull(form.elecContractEnd),
            payment_method:      form.elecPayment,
            meter_type:          form.elecMeterType,
            day_rate:            toNumberOrNull(form.elecDayRate),
            night_rate:          toNumberOrNull(form.elecNightRate),
            eve_weekend_rate:    toNumberOrNull(form.elecEveRate),
            eac_rate:            toNumberOrNull(form.elecEseRate),
            standing_charge:     toNumberOrNull(form.elecStandingCharge),
            mpan_top_line:       form.elecSupplyNumber         || null,
            mpan_core:           form.mpan                     || null,
            average_bill_amount: toNumberOrNull(form.elecAvgBill),
            bill_type:           form.elecBillType             || "MONTHLY",
            average_bill_range:  form.elecBillRange            || null,
            msn_no:              form.elecMSN                  || null,
          })
        );
      }

      if (showGas) {
        formData.append(
          "gas_details",
          JSON.stringify({
            current_supplier:    form.gasSupplier,
            customer_account_no: form.gasAccount              || null,
            month_and_year:      toMonthOrNull(form.gasMonthYear),
            contract_end_date:   toDateOrNull(form.gasContractEnd),
            payment_method:      form.gasPayment,
            annual_consumption:  toNumberOrNull(form.gasAnnualConsumption),
            day_rate:            toNumberOrNull(form.gasDayRate),
            standing_charge:     toNumberOrNull(form.gasStandingCharge),
            mprn_no:             form.gasMprnNumber            || null,
            average_bill_amount: toNumberOrNull(form.gasAvgBill),
            billing_frequency:   form.gasBillingFreq           || "MONTHLY",
            average_bill_range:  form.gasBillRange             || null,
            msn_no:              form.gasMSN                   || null,
          })
        );
      }

      formData.append(
        "quality_review",
        JSON.stringify({
          email:            form.email,
          callback_date:    form.callbackDate    || null,
          agent_feedback:   form.agentFeedback,
          quality_feedback: form.qualityFeedback,
          lead_disposition: form.leadDisposition,
          reviewed_by:      null,
        })
      );

      // ── Multiple VOX files ──────────────────────────────  ← CHANGED
      if (form.voxFiles && form.voxFiles.length > 0) {
        form.voxFiles.forEach((file) => {
          formData.append("vox_files", file);   // same field name for every file
        });
      }

      if (form.attachments && form.attachments.length > 0) {
    form.attachments.forEach((file) => {
      formData.append("attachments", file);
    });
  }

      const response = await axiosInstance.post(
        "/leads/create",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log(response.data);
      return true;

    } catch (error) {
      console.error(error);

      const message = error?.response?.data?.message || "Something went wrong";

      if (message.includes("leads_mpan_key")) {
        setErrors((prev) => ({ ...prev, mpan: "This MPAN already exists" }));
      } else if (message.includes("electricity_details_mpan_core_unique")) {
        setErrors((prev) => ({ ...prev, mpan: "This MPAN Core already exists" }));
      } else if (message.includes("gas_details_mprn_no_key")) {
        setErrors((prev) => ({ ...prev, gasMprnNumber: "This MPRN already exists" }));
      } else {
        setServerError(message);
      }

      return false;

    } finally {
      setIsSaving(false);
    }
  };

  return {
    form,
    errors,
    isSaving,
    serverError,
    setField,
    removeVoxFile,
    removeAttachment,
    reset,
    saveLead,
    setServerError,
  };
}